"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getTokens = exports.getTokensFromAll = exports.getTokensFromCookies = exports.getTokensFromLocalStorage = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _clientStorage = require("../../constants/clientStorage");
var _clientStorage2 = require("../clientStorage");
var _isTokensValid = _interopRequireDefault(require("./isTokensValid"));

/**
 * gets auth tokens from localStorage
 */
var getTokensFromLocalStorage = function getTokensFromLocalStorage() {
  var accessToken = (0, _clientStorage2.getItem)('accessToken', _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE);
  var idToken = (0, _clientStorage2.getItem)('idToken', _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE);
  return {
    accessToken: _lodash.default.isString(accessToken) ? accessToken : null,
    idToken: _lodash.default.isString(idToken) ? idToken : null
  };
};
/**
 * gets auth tokens from cookies
 */

exports.getTokensFromLocalStorage = getTokensFromLocalStorage;
var getTokensFromCookies = function getTokensFromCookies() {
  var accessToken = (0, _clientStorage2.getItem)('accessToken', _clientStorage.CLIENT_STORAGE_COOKIES);
  var idToken = (0, _clientStorage2.getItem)('idToken', _clientStorage.CLIENT_STORAGE_COOKIES);
  return {
    accessToken: _lodash.default.isString(accessToken) ? accessToken : null,
    idToken: _lodash.default.isString(idToken) ? idToken : null
  };
};
/**
 * Check all supported client storage types for tokens
 */

exports.getTokensFromCookies = getTokensFromCookies;
var getTokensFromAll = function getTokensFromAll() {
  var tokens; // get tokens from local storage

  tokens = getTokensFromLocalStorage();
  if (!(0, _isTokensValid.default)(tokens)) {
    // if we do not get valid tokens, try cookies
    tokens = getTokensFromCookies();
  }
  return tokens;
};
exports.getTokensFromAll = getTokensFromAll;
var getTokens = function getTokens(clientStorageType) {
  switch (clientStorageType) {
    case _clientStorage.CLIENT_STORAGE_COOKIES:
      return getTokensFromCookies();
    case _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE:
      return getTokensFromLocalStorage();
    case _clientStorage.CLIENT_STORAGE_ALL:
    default:
      return getTokensFromAll();
  }
};
exports.getTokens = getTokens;
var _default = getTokens;
exports.default = _default;